module.exports = __webpack_public_path__ + "1772aa4ad5b73f27456cee77efc5a649.woff";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-solid-900.woff
// module id = 355
// module chunks = 0